export default "__VITE_ASSET__B_H6g0vl__"